/**
 * Знак «Селлер-Штаба» — ровная «Ш» из трёх брусков на общем основании (вариант A, выбран владельцем;
 * C:/tmp/rebrand/icons/mark.svg, сетка 48). Рисуется вручную в SVG, не растром и не иконкой из набора.
 *
 * tile — знак цвета «Бумага» на чернильной плитке со скруглением 11/48, как иконка приложения
 * и аватар бота; plain — чернилами без подложки. Цвет — только «Чернила»: знак не бывает статусом.
 */

/** Контур знака на сетке 48 — дословно из mark.svg. */
const MARK_PATH = 'M6 8A2 2 0 0 1 8 6H12A2 2 0 0 1 14 8V34H20V8A2 2 0 0 1 22 6H26A2 2 0 0 1 28 8V34H34V8A2 2 0 0 1 36 6H40A2 2 0 0 1 42 8V40A2 2 0 0 1 40 42H8A2 2 0 0 1 6 40Z'

export function Mark(
  { size = 32, variant = 'tile', title }: { size?: number; variant?: 'tile' | 'plain'; title?: string },
): React.JSX.Element {
  const a11y = title !== undefined ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true as const }
  return (
    <svg className={'mark mark-' + variant} width={size} height={size} viewBox="0 0 48 48" focusable="false" {...a11y}>
      {variant === 'tile' ? (
        <>
          <rect width="48" height="48" rx="11" className="mark-tile" />
          {/* Знак уменьшен до 25/48 и стоит по центру: при круглой обрезке углы остаются внутри. */}
          <g transform="translate(7.3333 7.3333) scale(0.6944)"><path d={MARK_PATH} className="mark-glyph" /></g>
        </>
      ) : (
        <path d={MARK_PATH} className="mark-glyph" />
      )}
    </svg>
  )
}

/** Словесный знак: Manrope 800 чернилами, трекинг −0,02 em (03, раздел 7). */
export function Wordmark(): React.JSX.Element {
  return <span className="wordmark">Селлер-Штаб</span>
}
